import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

interface DeliveryPlatform {
  name: string;
  logo: string;
  url: string;
}

@Component({
  selector: 'app-order-chooser-modal',
  templateUrl: './order-chooser-modal.component.html',
  styleUrls: ['./order-chooser-modal.component.css']
})
export class OrderChooserModalComponent {
  platforms: DeliveryPlatform[] = [
    {
      name: 'Uber Eats',
      logo: 'assets/img1/app_logo/uber_eats_logo.png',
      url: 'https://www.ubereats.com/ca-fr/store/resto-pita-shawarma-inc*/rtGSD_kGXLyqQDNrsAbaJw?srsltid=AfmBOoqgS-JqrPb2LPd6kFuiVhBPdOrmVWfy5chdX2IERKloog1Plk5o'
    },
    {
      name: 'DoorDash',
      logo: 'assets/img1/app_logo/doordash_logo.png',
      url: 'https://www.doordash.com/store/resto-pita-shawarma-l%C3%A9vis-49069485/114938152/?srsltid=AfmBOooHaipFp_VkDEzlfdU4lkki5m3b7P-DWIpro0NuOiiWiIHyC8qo&utm_source=native_app_banner&web_consumer_id=dx_ba8eef683a90496d849f921338599705'
    },
    {
      name: 'Yuko Food',
      logo: 'assets/img1/app_logo/yuko_food_logo.png',
      url: 'https://yukofood.com/'
    }
  ];

  constructor(public activeModal: NgbActiveModal) { }

  close(): void {
    this.activeModal.dismiss('close');
  }

  selectPlatform(): void {
    this.activeModal.close('platform-selected');
  }
}
